// extracted by mini-css-extract-plugin
var _1 = "FileUploadMenuItem-module__input--LTs2L";
export { _1 as "input" }
